// removed by extract-text-webpack-plugin
module.exports = {"root":"qempo_StatisticCard_root-3KPba2S","cardStatisticsWrap":"qempo_StatisticCard_cardStatisticsWrap-2s1K9Q3","cardStatisticsContent":"qempo_StatisticCard_cardStatisticsContent-39Z00zk","dataWrap":"qempo_StatisticCard_dataWrap-24NwcIP","verticalLine":"qempo_StatisticCard_verticalLine-3ViUIYJ"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/home/elements/StatisticCard/StatisticCard.scss
// module id = 2290
// module chunks = 0